export default __webpack_public_path__ + "static/media/pic12.66a437ec.jpg";